module.exports = __webpack_public_path__ + "message.svg?26b0b5cc6350a8fbbebd0d62ccda80da";